import React from 'react';
import { Clock, Sparkles } from 'lucide-react';
import { useTranslation } from '../../i18n/hooks/useTranslation';
import { useTheme } from '../../contexts/ThemeContext';

interface ComingSoonProps {
  featureName: string;
  description?: string;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ featureName, description }) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className={`w-20 h-20 rounded-full flex items-center justify-center ${
              theme.mode === 'dark' 
                ? 'bg-gray-700' 
                : 'bg-gray-100'
            }`}>
              <Clock className={`w-10 h-10 ${
                theme.mode === 'dark' 
                  ? 'text-gray-400' 
                  : 'text-gray-500'
              }`} />
            </div>
            <div className="absolute -top-1 -right-1">
              <Sparkles className="w-6 h-6 text-primary-500" />
            </div>
          </div>
        </div>

        {/* Title */}
        <h2 className={`text-2xl font-bold mb-3 ${
          theme.mode === 'dark' 
            ? 'text-gray-100' 
            : 'text-gray-900'
        }`}>
          Coming Soon
        </h2>

        {/* Feature Name */}
        <h3 className={`text-xl font-semibold mb-2 ${
          theme.mode === 'dark' 
            ? 'text-gray-300' 
            : 'text-gray-700'
        }`}>
          {featureName}
        </h3>

        {/* Description */}
        {description && (
          <p className={`text-sm mb-6 ${
            theme.mode === 'dark' 
              ? 'text-gray-400' 
              : 'text-gray-600'
          }`}>
            {description}
          </p>
        )}

        {/* Message */}
        <p className={`text-sm ${
          theme.mode === 'dark' 
            ? 'text-gray-400' 
            : 'text-gray-600'
        }`}>
          We're working hard to bring you this exciting new feature. Stay tuned!
        </p>
      </div>
    </div>
  );
};
